module.exports = __webpack_public_path__ + "img/TS6201-302.bbd849ff.jpg";